import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-modal-header-wizard',
    templateUrl: './modal-header-wizard.component.html',
    styleUrls: ['./modal-header-wizard.component.scss'],
    standalone: false
})
export class ModalHeaderWizardComponent implements OnInit {
    @Input() pages;
    @Input() listType;
    constructor() { }

    ngOnInit() {
    }

}
